/* Shared internal-regulations catalog store. */
import { listRegulations } from "./api";
import { createListStore } from "./createListStore";

const store = createListStore({
  fetcher: listRegulations,
  staleMs: 30_000,
  name: "regulations",
});

export const fetchRegulations = store.fetch;
export const prefetchRegulations = store.prefetch;
export const invalidateRegulations = store.invalidate;

export function useRegulations() {
  const { data, loading, error, refresh } = store.useData();
  return {
    regulations: data || [],
    loading,
    error,
    refresh,
  };
}
